export default class PrimaryNav {
    constructor() {
        this.navOpen = document.querySelector(".js-nav-open");
        this.navClose = document.querySelector(".js-nav-close");
        this.nav = document.querySelector(".js-nav");
        this.topMenu = document.querySelector(".top-menu");
        this.topPortfolio = document.querySelector(".top-portfolio");
        this.navList = document.querySelector(".nav-column nav ul");

        this.init();
    }

    init() {
        if (this.navOpen) {
            this.navOpen.addEventListener("click", this.openNav.bind(this));
        }

        if (this.navClose) {
            this.navClose.addEventListener("click", this.closeNav.bind(this));
        }

        window.addEventListener("keydown", this.closeNavOnEscape.bind(this));
        window.addEventListener("resize", this.closeNav.bind(this));
    }

    openNav(e) {
        e.preventDefault();
        this.navList.insertAdjacentElement("afterend", this.topPortfolio);
        this.navList.insertAdjacentElement("afterend", this.topMenu);
        this.nav.classList.add("active");
        document.body.classList.add("nav-open");
        this.nav.attributes["aria-hidden"].value = "false";
    }

    closeNav(e) {
        e.preventDefault();
        this.nav.classList.remove("active");
        document.body.classList.remove("nav-open");
        this.nav.attributes["aria-hidden"].value = "true";
        this.nav.insertAdjacentElement("beforeend", this.topMenu);
        this.nav.insertAdjacentElement("beforeend", this.topPortfolio);
    }

    closeNavOnEscape(e) {
        if (e.key === "Escape") {
            this.nav.classList.remove("active");
            this.nav.attributes["aria-hidden"].value = "true";
            this.nav.insertAdjacentElement("beforeend", this.topMenu);
            this.nav.insertAdjacentElement("beforeend", this.topPortfolio);
        }
    }
}
